export default "__VITE_ASSET__Cmori_5M__"